import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from "react";
import Figure from "./Figure";
import getClassNameFactory from "../../utilities/classNames";
var getClassName = getClassNameFactory("Figure");

var rehydrator = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren, extra) {
    var readData, captionNode, childrenNode, reactifiedCaption, reactifiedChildren, props;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // eslint-disable-next-line
            readData = function readData(prop) {
              var data = domNode.getAttribute("data-".concat(prop));
              return data ? JSON.parse(data) : null;
            };

            captionNode = domNode.querySelector(".".concat(getClassName({
              descendantName: "caption"
            })));
            childrenNode = domNode.querySelector(".".concat(getClassName({
              descendantName: "imageWrapper"
            })));

            if (!captionNode) {
              _context.next = 9;
              break;
            }

            _context.next = 6;
            return rehydrateChildren(captionNode, extra);

          case 6:
            _context.t0 = _context.sent;
            _context.next = 10;
            break;

          case 9:
            _context.t0 = null;

          case 10:
            reactifiedCaption = _context.t0;

            if (!childrenNode) {
              _context.next = 17;
              break;
            }

            _context.next = 14;
            return rehydrateChildren(childrenNode, extra);

          case 14:
            _context.t1 = _context.sent;
            _context.next = 18;
            break;

          case 17:
            _context.t1 = null;

          case 18:
            reactifiedChildren = _context.t1;
            props = {
              attribution: domNode.getAttribute("data-attribution"),
              ariaLabel: domNode.getAttribute("aria-label"),
              altText: domNode.getAttribute("altText"),
              caption: reactifiedCaption,
              children: reactifiedChildren,
              expandable: readData("expandable"),
              expandableUrl: domNode.getAttribute("data-expandable-url")
            };
            return _context.abrupt("return", /*#__PURE__*/React.createElement(Figure, props));

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function rehydrator(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

export default rehydrator;